import { featurePreviews } from '../../../mocks/homeData';
import { Link } from 'react-router-dom';

export default function FeaturesPreview() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-4">
              Built for Speed &amp; Scale
            </h2>
            <p className="text-zinc-500 text-lg max-w-xl mx-auto">
              Everything you need to find, filter, and book loads — without the friction.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featurePreviews.map((feature) => (
              <div
                key={feature.title}
                className="bg-zinc-50 rounded-card p-6 border border-zinc-100 hover:border-blue-200 hover:shadow-lifted transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-blue-600/10 rounded-lg mb-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${feature.icon} text-lg text-blue-600`}></i>
                  </div>
                </div>
                <h3 className="text-base font-bold text-zinc-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-zinc-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/features"
              className="inline-flex items-center gap-2 px-6 py-3 bg-zinc-900 text-white text-sm font-medium rounded-full hover:bg-zinc-800 transition-colors whitespace-nowrap"
            >
              See All Features
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}